import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI} from '../../API';
import { logFrontendActivity } from '../General/activityLogger';

export const claimsslice = createSlice({
    name: 'claims',
    initialState: {
        data: [],
        meta: {
            page: 1,
            per_page: 10,
            start_date: "",
            end_date: "",
            claim_type: [],
            tracking_number: "",
            claim_status: [],
            sorting: JSON.stringify([{
                field: 'created_at',
                sort: 'desc',
            }])
        },
        loading: false,
        hasErrors: false,
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getClaimsData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getClaimsDataSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                meta: action && action.payload && action.payload.data,
                hasErrors: false,
                loading: false
            }
        },
        getClaimsDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        postClaimsData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        postClaimsDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" },
            }
        },
        postClaimsDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }
            }
        },
        
        resetclaims: (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
                notification: { show: false, messageContent: "", messageType: "success" }
            }
        },


    }
})
export const { getClaimsData, getClaimsDataSuccess, getClaimsDataFailure, postClaimsData, postClaimsDataSuccess, postClaimsDataFailure,
    resetclaims } = claimsslice.actions;


export const fetchClaimsData = (meta) => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');

    return (dispatch) => {
        dispatch(getClaimsData());
        try {
            LABELGENAPI
                .get('/claimsInfo?' + qs)
                .then(function (response) {
                    dispatch(getClaimsDataSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getClaimsDataFailure(error.response));
                });
        } catch (error) {
            dispatch(getClaimsDataFailure());
        }
    };
};

export const storeClaimsData =  (userid, data, meta) => dispatch => {
    
    const obj = {};
    for (let [key, value] of data.entries()) {
        obj[key] = value;
    }
    dispatch(postClaimsData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/claimsInfo', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postClaimsDataSuccess(response));
                dispatch(fetchClaimsData(meta));
                logFrontendActivity({
                    group: 'REPORTS',
                    subgroup: 'CLAIMS',
                    action: 'SUCCESS',
                    request_data: obj,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });   
            }).catch(function (error) {
                dispatch(postClaimsDataFailure(error.response));
                logFrontendActivity({
                    group: 'REPORTS',
                    subgroup: 'CLAIMS',
                    action: 'FAILURE',
                    request_data: obj,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });   
            })
    }
    catch (error) {
        dispatch(postClaimsDataFailure(error.response));
        logFrontendActivity({
            group: 'REPORTS',
            subgroup: 'CLAIMS',
            action: 'FAILURE',
            request_data: obj,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}

export const resetClaimsState = data => dispatch => {
    dispatch(resetclaims());
}
export default claimsslice.reducer;
